import _ from 'underscore';
import xtend from 'xtend';

import Store from '../lib/store/store-v2';

export default function (domainName, apiBus) {
    const KEY = (domainName == 'listing') ? 'preferenceID' : 'prefID';
    var state = Store();

    var apiActions = Store.ApiActions(state, KEY, {
        setPreferenceAsDefault: function (resp) {
            // This call has some very weird output that we have to fix on
            // the Crud Server
            Store.ApiActions.prototype.get.call(this, {
                errors: {
                    hasError: false,
                    message: null
                },
                data: resp,
                meta: null
            });
        }
    });
    Store.SubscribeToApi(apiActions, apiBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, { data: _.toArray(data.data) }));
        })
    };
};
